import { API } from "./api";



export const getSystemHealthService = async (): Promise<{
    event_alert: boolean,
    event_collector: boolean,
    event_export: boolean,
    event_management: boolean,
    event_validator: boolean,
    core: boolean,
    license: number
}>=>{
    try {
        const res = await API.post(`/v1/health`);
        return res.data;
    } catch (error) {
        throw error
    }
}

